import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { getSelectedTabstate, handleShowComparePriceModal, UsertourAction, publicEditFun } from "../../action/index.js";
import BuildingSummary from "./BuildingSummary.js";
import BuildingController from "../BuildingController/BuildingController";
import * as cuComponent from "../../redux/reducers/building_component/componentReducer.js";
import OrderNow from "../ControlPanel/Common/OrderNow.js";
import { const_var } from "../../redux/reducers/reducer.js";
import ScreenShareControlPanel from "../../screen-share/components/screenShareControlPanel/ScreenShareControlPanel.tsx";
import { handleCommonModal, handleProductModal } from "../../action/quote_order/leadcustomer.action.js";
import { CheckCaptureModalImage } from "../../action/extra_options/orderExtras.action.js";
import { handleSaveLatter, handleSavePublicQuote } from "../../action/quote_order/quote.action.js";
import { downloadOnClick, prepareTwoDMapData } from "../../action/2d_mapping/twoDMap.action.js";
import { ShowMeasure } from "../../action";
import SaveButtonFunction from "../ControlPanel/Common/SaveButton.js";
import { SaveButton } from "../../Intel/component/saveButton.js";

let checkactivelogin = false;
class Header extends Component {
  constructor(props) {
    super(props);

    this.childRef = createRef();

    this.state = {
      isControlPanelVisible: false,
      isEndSessionConfirmationDialogVisible: false,
      isExiting: "",
      room: null,
      videoTrack: null,
      loading: { type: "none" },
      isShowCopiedStatus: false
    };
  }

  clickbuildingfullview = () => {
    const checkfullbuilding = document.querySelector(".activethumb-view");
    if (checkfullbuilding !== null) {
      document.querySelector(".togglebuildingview").click();
      setTimeout(() => {
        cuComponent.onResize();
      }, 500);
      this.props.UsertourAction(true, "", 0);
    } else {
      this.props.UsertourAction(true, "", 0);
    }
  };

  componentWillMount() {
    if (localStorage.getItem("userData") != undefined) {
      checkactivelogin = true;
    } else {
      checkactivelogin = false;
    }
  }

  handleCompare() {
    if (this.props.const_var.is_loader == false) {
      this.props.const_var.ComparisionDataArray = {};
      this.props.handleShowComparePriceModal();
    }
  }

  onSaveClick = async () => {
    await this.props.downloadOnClick(false);
    await this.props.prepareTwoDMapData();
    //autoGeneratedPDF();
    if (const_var.callMesure) {
      this.props.ShowMeasure("save")
    }
  };

  saveShareClick() {
    const { loginSession, crmSetting, isPublicEdit, i_g_A_y } = this.props.const_var;
    if (crmSetting.is_module_name == 'inventory') {
      this.props.handleProductModal();
    } else {
      if (isPublicEdit != true) {
        if (crmSetting.form_action == "edit" && i_g_A_y.length > 0) {
          this.props.CheckCaptureModalImage('open');
        } else {
          if (loginSession == false) {
            this.props.handleSaveLatter('open');
          } else {
            this.props.handleCommonModal('lead_customer', 'save');
          }
        }
      } else {
        this.props.handleSavePublicQuote('open');
      }
      this.onSaveClick();
    }
  }

  render() {
    const { crmSetting, selectedTabstate, loginSession, is_quote_Edit } = this.props.const_var;
    const { nonLoggedInpriceCompareData, params } = this.props;

    let selectedComparePriceDataForNonLoggedIn = [];
    if (!loginSession && selectedTabstate != "statechange" && nonLoggedInpriceCompareData) {
      const key = `selectedState_${params.p_s_n}`;
      selectedComparePriceDataForNonLoggedIn = nonLoggedInpriceCompareData[key];
    }

    // Determine the class name based on conditions
    const isInventoryModule = crmSetting.is_module_name === "inventory";
    const isTabStateChange = selectedTabstate === "statechange" || selectedTabstate === "buildstyle" || selectedTabstate === "loginstyletab";
    const isConditionsMet = isInventoryModule || is_quote_Edit === true;
    const isNonLoggedInWithComparePriceData = selectedComparePriceDataForNonLoggedIn?.length > 0 && !loginSession && selectedTabstate != "statechange";
    const className =
      isInventoryModule && isTabStateChange && !isNonLoggedInWithComparePriceData
        ? "d-none compare-price"
        : isConditionsMet && !isNonLoggedInWithComparePriceData
          ? "d-none compare-price"
          : this.props.const_var.stateData != undefined && this.props.const_var.stateData.hide_price_calculation == 1
            ? "d-none compare-price"
            : "compare-price";

    const navBoxClassName =
      isInventoryModule && isTabStateChange && !isNonLoggedInWithComparePriceData
        ? "d-none"
        : isConditionsMet && !isNonLoggedInWithComparePriceData
          ? "d-none"
          : this.props.const_var.stateData != undefined && this.props.const_var.stateData.hide_price_calculation == 1
            ? "d-none"
            : "nav-box";

    const isLogin = this.props.const_var.loginSession;
    const hideCompareOption = this.props.const_var.hideCompareOption && !isLogin;
    let isCustomBuilding = this.props?.const_var?.b_o_J_1[this.props?.params?.p_b_t] == "Custom Buildings" && !isLogin;
    const isHidePriceCalculation = this.props?.const_var?.stateData?.hide_price_calculation == 0;
    let isEditFullViewEnable = this.props.const_var.ishideLeftNevigationBar != undefined && this.props.const_var.ishideLeftNevigationBar == true ? true : false;
    let isCompareExsist = true;

    if (!this.props.const_var.loginSession && params.p_s_n && this.props.const_var.stateManufacturerAcordingAPI && this.props.const_var.stateManufacturerAcordingAPI[params.p_s_n] != undefined) {
      isCompareExsist = this.props.const_var.stateManufacturerAcordingAPI[params.p_s_n].price_comparision != undefined && this.props.const_var.stateManufacturerAcordingAPI[params.p_s_n].price_comparision.length > 0 ? true : false;
    }

    if (
      this.props.const_var.loginSession &&
      params.p_s_n &&
      this.props.const_var.stateManufacturerAcordingAPI &&
      this.props.const_var.stateManufacturerAcordingAPI[params.p_s_n] != undefined &&
      this.props.const_var.stateManufacturerAcordingAPI[params.p_s_n].length < 2
    ) {
      isCompareExsist = false;
    }
    let showCompareForLT = (this.props.isLTBuilding || (this.props.const_var.defaultBuildingArr?.[this.props.defaultBuilding]?.image_name?.includes('shape') || this.props.const_var.defaultBuildingArr?.[this.props.defaultBuilding]?.image_name?.includes('Front_to_Back'))) ? false : true

    const checkHiddenClass = document.body.classList.contains('hidden-customer-edit')

    return (
      <header className={`${isEditFullViewEnable == true ? "hideshadow" : ""}`}>
        <div
          className={this.props.selectedTabstate == "statechange" || this.props.selectedTabstate == "buildstyle" || this.props.selectedTabstate == "loginstyletab" ? "header-wrapper-state-screen" : "header-wrapper"}
        >
          <div className="nav-left">
            <div className="nav-box">
              {this.props.const_var.crmSetting.is_quote_Edit == true && this.props.const_var.isPublicEdit == true ? (
                <div className={"nav-box-white"}>
                  <div class="d-lg-block">
                    <button
                      id="save_update_orderquote_automation"
                      onClick={(e) => {
                        this.props.publicEditFun(this.props.const_var.isPublicEdit, "fromheader");
                      }}
                      className={this.props.const_var.isPublicEdit == true ? "btn btn-primary  " : " btn btn-primary d-none"}
                    >
                      <span className="text">Edit Configuration</span>
                      <span className="icon">
                        <i className="icon-double-arrow-ico"></i>
                      </span>
                    </button>
                  </div>
                </div>
              ) : null}
              {this.props.const_var.crmSetting.order_now == true &&
                this.props.const_var.checkmoreCustomizeFlag == false &&
                this.props.const_var.stateData &&
                this.props.const_var.stateData.hide_price_calculation == 0 &&
                (this.props.const_var.crmSetting.is_show_cta == true || this.props.const_var.crmSetting.is_show_cta == undefined) ? (
                <div
                  className={
                    this.props.selectedTabstate == "statechange" ||
                      this.props.selectedTabstate == "buildstyle" ||
                      this.props.selectedTabstate == "loginstyletab" ||
                      this.props.const_var.crmSetting.is_quote_Edit == true ||
                      this.props.const_var.isPublicEdit == true
                      ? "d-none a1 order-now-btn-wrp"
                      : "a order-now-btn-wrp"
                  }
                >
                  {this.props.const_var.loginSession === false ? (
                    this.props.const_var.crmSetting.is_module_name === "inventory" ||
                      (this.props.const_var.isPublicEdit == true && this.props.const_var.crmSetting.is_quote_Edit == true) ||
                      this.props.const_var.isPublicEdit == true ? (
                      <></>
                    ) : (
                      <>
                        {
                          !const_var?.is_intel &&

                          <div className={this.props.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com' ? "header-order-btn-wrp btn-left-border" : "header-order-btn-wrp"}>
                            <OrderNow
                              title="Order"
                              i_g_A_y={this.props.const_var.i_g_A_y}
                              order_now={this.props.const_var.crmSetting.order_now}
                              is_quote_Edit={this.props.const_var.crmSetting.is_quote_Edit}
                              form_action={this.props.const_var.crmSetting.form_action}
                              is_loggedin={this.props.const_var.loginSession}
                            />
                          </div>
                        }
                      </>
                    )
                  ) : null}
                </div>
              ) : null}
              {
                this.props.const_var.crmSetting.order_now == true &&
                  this.props.const_var.checkmoreCustomizeFlag == false &&
                  this.props.const_var.stateData &&
                  this.props.const_var.stateData.hide_price_calculation == 0 &&
                  (
                    this.props.const_var.crmSetting.is_show_cta == true ||
                    this.props.const_var.crmSetting.is_show_cta == undefined
                  ) &&
                  this.props.const_var.loginSession === false &&
                  this.props.const_var.crmSetting.is_module_name !== "inventory" &&
                  !(
                    this.props.const_var.isPublicEdit === true &&
                    this.props.const_var.crmSetting.is_quote_Edit === true
                  ) &&
                  this.props.const_var.isPublicEdit !== true
                  ? (
                    <div className='nav-box-white a save-icon-header-wrp'>
                      {
                        this.props.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || this.props.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com"
                          ?
                          <SaveButtonFunction headerShow={true} class_name={this.props.const_var.crmSetting.main_domain_url != 'metalcarportdepotllc.com' ? (const_var.is_loader == false ? "btn btn-block btn-primary btn-show-order-enable btn-share" : "btn btn-block btn-primary btn-show-order-enable btn-share disabled") : "d-none"} />
                          :
                          <>
                            {
                              !const_var?.is_intel &&

                              <span className={this.props.const_var.crmSetting.main_domain_url != 'metalcarportdepotllc.com' ? "icon icon-save" : "d-none"} onClick={() => this.saveShareClick()}></span>
                            }
                          </>
                      }
                    </div>
                  )
                  : ((checkHiddenClass && this.props.const_var.isPublicEdit === true) || !this.props.const_var.isPublicEdit) && (<div className="nav-box-white">
                    {
                      !const_var?.is_intel ?
                      <SaveButtonFunction headerShow={true} class_name={this.props.const_var.crmSetting.main_domain_url != 'metalcarportdepotllc.com' ? (const_var.is_loader == false? "btn btn-block btn-primary btn-share" : "btn btn-block btn-primary btn-share disabled") : "d-none"}/>
                               :
                        <SaveButton  postData={this.props.const_var.post_data}/>
                    }
                  </div>)
              }

              {isEditFullViewEnable == false && (
                <div className="nav-box-light">
                  <BuildingSummary />
                </div>
              )}
            </div>
            {
              !this.props.const_var.is_intel &&
              <>

                {/* !this.props.isLTBuilding */ showCompareForLT && isCompareExsist && isHidePriceCalculation && !hideCompareOption && !isCustomBuilding && !this.props.const_var.checkmoreCustomizeFlag && (
                  <div className={navBoxClassName}>
                    {" "}
                    <div className={className} onClick={this.handleCompare.bind(this)} data-tut="compare-data-tut">
                      <i className="icon-compare-price-ico"></i>
                      {window.innerWidth > 1600 ? (
                        <span className="text ">
                          <small>{this.props.const_var.loginSession ? "For best deals!" : "For deals!"}</small>
                          <strong>{this.props.const_var.loginSession ? "Compare Price!" : "Compare"}</strong>
                        </span>
                      ) : (
                        <span className="text">
                          <strong>Compare</strong>
                        </span>
                      )}
                    </div>
                  </div>
                )}
                {!!navigator.mediaDevices?.getDisplayMedia && getOS() !== "Android" && getOS() !== "iOS" && (
                  <>
                    {(this.props.const_var.loginSession == true) && (
                      <ScreenShareControlPanel navBoxClassName={navBoxClassName} className={className} state={this.state} setState={(key, value) => this.setState((prev) => ({ ...prev, [key]: value }))} />
                    )}
                  </>
                )}
              </>
            }
          </div>
          <div className="nav-right">
            <div className={this.props.selectedTabstate == "statechange" || this.props.selectedTabstate == "loginstyletab" ? "d-none" : ""}>
              <BuildingController tourbind="buildingcontrollerdesktop" />
            </div>
          </div>
        </div>
      </header>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state.reducer, ...state.reducer.const_var, ...state.loginReducer, ...state.leadcustomerReducer, ...state.screenShareReducer };
};
const mapDispatchToProps = {
  getSelectedTabstate,
  handleShowComparePriceModal,
  UsertourAction,
  publicEditFun,
  handleCommonModal,
  handleProductModal,
  CheckCaptureModalImage,
  handleSavePublicQuote,
  handleSaveLatter,
  downloadOnClick,
  prepareTwoDMapData,
  ShowMeasure
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);

function getOS() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/windows/i.test(userAgent)) {
    return "Windows";
  }
  if (/android/i.test(userAgent)) {
    return "Android";
  }
  if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(navigator.platform)) {
    return "macOS";
  }
  if (/iPhone|iPad|iPod/.test(userAgent)) {
    return "iOS";
  }
  return "Unknown OS";
}
